// screens/registration/Region.js
import React, { useEffect, useMemo, useState } from "react";
import { Box, useTheme ,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useFormik } from "formik";
import { useNavigate,useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import { toast, Toaster } from "react-hot-toast";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import MultiSelectDropdown from "../../../components/MultiSelectionDropdown";
import CustomDropdownInput from "../../../components/CustomDropdown";
import profiledone from "../../../assets/profiledone.svg";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import { getCountriesByRegions,  getCitiesByCountryNames,} from "./Helper";
import { setProfileDraft, getProfileDraft } from "./ProfileDraft";


const Region = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
const location = useLocation();
const [isContinueClicked, setIsContinueClicked] = useState(false);
const [isExecDropdownOpen, setIsExecDropdownOpen] = useState(false);
const [isReferralMode, setIsReferralMode] = useState(false);


  const navigate = useNavigate();
  const { t } = useTranslation();

  // Tokens/IDs (adjust to your store/shape)
  const profileUpdateToken =
    useSelector((s) => s.auth?.profileUpdateToken) ||
    localStorage.getItem("profileUpdateToken");




  // UI state
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);

  // Regions for registration/profile come from a static allowed list (NOT assigned-zone)
  // const [regionOptions, setRegionOptions] = useState([]);
const openedFromLocation = location?.state?.source === "location";


const formik = useFormik({
  initialValues: {
    regions: [],
    countries: [],
    cities: [],
      account_executive_id: "", 
  },
  onSubmit: async (values) => {
    try {

      setLoading(true);

      // Merge into draft
      setProfileDraft({
        territory_zone: values.regions || [],
        territory_countries: values.countries || [],
        territory_cities: values.cities || [],
        // account_executive_id: values.account_executive_id || null,
        account_executive_id:
  values.account_executive_id === "" ? null : values.account_executive_id,
      });

      // toast.success("Territory saved");
  localStorage.removeItem("invited-id");
      // Navigate next (face-scan or review screen)
      setTimeout(() => {
        if (openedFromLocation) {
          navigate("/create-profile", { state: { source: "region" } });
        } else {
  navigate("/registration-verification");
        }
        setLoading(false);
      }, 1000);

    } catch (e) {
      toast.error("Failed to save region");
      setLoading(false);
    }
  },
});


const [regionOptions, setRegionOptions] = useState([]);
const [zonesLoading, setZonesLoading] = useState(false);

// Whenever executive changes → fetch assigned zones
useEffect(() => {
  const execId = formik.values.account_executive_id;
  if (!execId) {
    setRegionOptions([]);
    return;
  }

const fetchZones = async () => {
  try {
    setZonesLoading(true);
    const res = await fetch(`${BASE_URL}/account-executive/${execId}/assigned-zone`);
    const data = await res.json();
    console.log("region from acx", data);

    if (!res.ok || data.error) throw new Error(data.message || "Failed to fetch zones");

    // ✅ format for MultiSelectDropdown
setRegionOptions(data.data?.territory_zone || []);


  } catch (err) {
    toast.error(err.message || "Error fetching zones");
    setRegionOptions([]);
  } finally {
    setZonesLoading(false);
  }
};

  fetchZones();
}, [formik.values.account_executive_id]);


  const [citiesLoading, setCitiesLoading] = useState(false);
const [cityOptions, setCityOptions] = useState([]);

useEffect(() => {
  if (!formik.values.countries.length) {
    setCityOptions([]);
    return;
  }

  setCitiesLoading(true);
  setTimeout(() => {  // mimic async call (country-state-city is sync, but you still want smooth UX)
    const result = getCitiesByCountryNames(formik.values.countries);
    setCityOptions(result);
    setCitiesLoading(false);
  }, 0);
}, [formik.values.countries]);

const toArray = (input) => {
  if (Array.isArray(input)) return input;
  if (input && input.target) return input.target.value ?? [];
  return [];
};
  // Cascade: countries from selected regions
  const countryOptions = useMemo(() => {
    if (!formik.values.regions.length) return [];
    return getCountriesByRegions(formik.values.regions).map((c) => c.name);
  }, [formik.values.regions]);



const handleRegionsChange = (input) => {
  // console.log("📌 handleRegionsChange input:", input);
  // alert("handleRegionsChange input: " + JSON.stringify(input));

  const vals = Array.isArray(input) 
    ? input 
    : input?.target?.value ?? [];

  console.log("✅ Parsed zone values:", vals);
  formik.setFieldValue("regions", vals);
  // formik.setFieldValue("countries", []);
  // formik.setFieldValue("cities", []);
};
const handleCountriesChange = (input) => {
  const vals = toArray(input);
  formik.setFieldValue("countries", vals);
  formik.setFieldValue("cities", []);
};

const handleCitiesChange = (input) => {
  const vals = toArray(input);
  formik.setFieldValue("cities", vals);
};




const [executives, setExecutives] = useState([]);
const [executivesLoading, setExecutivesLoading] = useState(false);




useEffect(() => {
  const fetchExecutives = async () => {
    try {
      setExecutivesLoading(true);
      const res = await fetch(`${BASE_URL}/super-admin/public/account-executives?no_pagination=true`);
      const data = await res.json();
      console.log("data",data)
      if (!res.ok || data.error) throw new Error(data.message || "Failed to load");
      setExecutives(data.data?.account_executives || []);
    } catch (err) {
      toast.error(err.message || "Error fetching executives");
    } finally {
      setExecutivesLoading(false);
    }
  };
  fetchExecutives();
}, []);



useEffect(() => {
  const referralCode = localStorage.getItem("invited-id");
  if (!referralCode) return;

  const fetchReferralExecutive = async () => {
    try {
      setIsReferralMode(true);
      setInitLoading(true);

      const res = await fetch(
        `${BASE_URL}/account-executive/by-referral-code/${referralCode}`
      );
      const data = await res.json();

      if (!res.ok || data.error) throw new Error(data.message);

      const exec = data.data.account_executive;

      // 1) Autofill executive ID
      formik.setFieldValue("account_executive_id", exec.id);

      // 2) Autofill territory zones
      setRegionOptions(exec.territory.zone || []);

      // 3) Prefill selected zones
      formik.setFieldValue("regions", exec.territory.zone || []);

    } catch (err) {
      toast.error(err.message || "Invalid referral code");
      setIsReferralMode(false);
    } finally {
      setInitLoading(false);
    }
  };

  fetchReferralExecutive();
}, []);

const sortedExecutives = useMemo(() => {
return [...executives].sort((a, b) =>
(a?.full_name ?? "").localeCompare(
b?.full_name ?? "",
undefined,
{ sensitivity: "base" } // A–Z, case-insensitive
)
);
}, [executives]);
  return (
    <Box sx={{ py: isMobile ? 5 : 8, px: 2, mt: isMobile ? 2 : 0 }}>
      {/* <Toaster /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          alignItems: "center",
        }}
      >
        <BaseCard
          maxWidth={
            isMobile ? "100%" : isTablet ? "70%" : isLaptop ? "70%" : "40%"
          }
        >
          {/* Stepper */}
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
              <Box
                sx={{
                  width: isMobile ? 35 : isTablet ? 70 : 93,
                  height: 2,
                  backgroundColor: "#091E4224",
                }}
              />
              
                 <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
            
              <Box
                sx={{
                  width: isMobile ? 35 : isTablet ? 70 : 93,
                  height: 2,
                  backgroundColor: "#091E4224",
                }}
              />
            <Box
                sx={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  backgroundColor: "#006EC2",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
        3
              </Box>

   <Box
                sx={{
                  width: isMobile ? 35 : isTablet ? 70 : 93,
                  height: 2,
                  backgroundColor: "#091E4224",
                }}
              />
                <Box
                sx={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  color: "#BCBFC2",
                  border: "2px solid  #091E4224",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
          4
              </Box>
            </Box>
          </Box>

       
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  <CustomText
    sx={{
      ...textStyles.h4,
      color: "#172B4D",
      textAlign: "left",
      fontSize: "24px",
    }}
  >
    {t("selectAccountExecutiveForCompany")}
  </CustomText>

  {/* Show loader only when referral API is loading */}
 {isReferralMode && initLoading && (
    <CircularProgress size={18} sx={{ color: "#006EC2" }} />
  )}
</Box>

          <form onSubmit={formik.handleSubmit} style={{ marginTop: "20px" }}>


       
       <ClickAwayListener onClickAway={() => setIsExecDropdownOpen(false)}>
  <Box>


<CustomDropdownInput
  label={t("selectAccountExecutive")}
  value={formik.values.account_executive_id}
  disabled={isReferralMode}
  loading={executivesLoading}
  enableSearch={true} // Enable the search feature
  onChange={(val) => {
    if (!isReferralMode && !executivesLoading) {
      formik.setFieldValue("account_executive_id", val);
      setIsExecDropdownOpen(false);
    }
  }}
options={sortedExecutives}
  getOptionLabel={(opt) => `${opt.full_name} (${opt.email})`}
  getOptionValue={(opt) => opt.id}
/>

  </Box>
</ClickAwayListener>


            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4,gap:1, }}>
            

              <CustomButton
                label={t("back")}
                 disabled={isContinueClicked} 
                onClick={() => navigate(-1)}
                size="medium"
                sx={{
                  fontSize:"16px",
                  px: 4,
                 backgroundColor: isContinueClicked ? "#f0f0f0" : "white", // light grey if disabled
    color: isContinueClicked ? "#999" : "black",
    "&:hover": {
      backgroundColor: isContinueClicked ? "#f0f0f0" : "white",
      color: isContinueClicked ? "#999" : "black",
    },
                }}
              />
              <CustomButton
               onClick={() => setIsContinueClicked(true)}  
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {loading && (
                      <CircularProgress size={18} sx={{ color: "#fff" }} />
                    )}
                    {t("next")}
                  </Box>
                }
                type="submit"
                size="medium"
                sx={{ px: 6, height: 20 }}
              />
            </Box>

          </form>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default Region;




